import { INPUT } from '$gbusiness/enums';
import InputRowModel from '$gbusiness/models/inputRow';
import { input } from '$gbusiness/helpers';

export const BANK_FORM: Array<InputRowModel> = [
  {
    items: [
      {
        label: 'SCREEN.STORES.BANK.COLS.NAME',
        value: 'name',
        input: INPUT.TEXT,
        gridSize: 12,
        validation: [input.requiredValidation],
      },
      {
        label: 'SCREEN.STORES.BANK.COLS.MEMO',
        value: 'settings.memo',
        input: INPUT.TEXTAREA,
        gridSize: 12,
      },
    ],
  },
];
